const skills = {
  principal: [
    ".NET / ASP.NET Core",
    "C#",
    "React",
    "React Native",
    "SQL Server",
  ],
  solid: [
    "TypeScript",
    "JavaScript",
    "Laravel",
    "MySQL",
    "REST APIs",
    "Entity Framework",
    "AWS",
    "Microservicios",
    "SOLID",
  ],
  additional: [
    "Microsoft Azure",
    "Firebase",
    "Docker",
    "Node.js",
    "NestJS",
    "Python",
    "IIS / Windows Server",
    "CI/CD",
    "Jira",
  ],
};

export default skills;
